import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getCategoriesWithProducts } from "../services/productService";
import HeroCarousel from "../components/HeroCarousel";
import { useCart } from "../context/CartContext";
import { translateText } from "../services/translationService";
import { formatPrice } from '../services/currencyService';

const MenPage = () => {
  const [newProducts, setNewProducts] = useState([]);
  const [translatedProducts, setTranslatedProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [favorites, setFavorites] = useState(new Set());
  const [isFirefox, setIsFirefox] = useState(false);
  const [language, setLanguage] = useState("fr");
  const [isTranslating, setIsTranslating] = useState(false);
  
  const { addToCart } = useCart();
  const navigate = useNavigate();

  // Dictionnaire de traduction pour les textes statiques
  const staticTranslations = {
    fr: {
      newCollection: "Nouvelle Collection",
      ourLatestArrivals: "Nos Dernières Arrivages",
      latestInnovations: "Découvrez nos dernières innovations pour hommes en avant-première avec des formulations naturelles exclusives",
      new: "Nouveau",
      addToCart: "Ajouter au panier",
      viewAllProducts: "Voir tous les produits",
      testimonials: "Témoignages",
      whatOurClientsSay: "Ce Que Disent Nos Clients",
      clientExperiences: "Découvrez les expériences de ceux qui ont déjà fait confiance à nos produits naturels",
      beardOilTransformed: "L'huile à barbe a complètement transformé ma routine de soin. Ingrédients naturels et résultats visibles dès la première semaine !",
      exceptionalQuality: "Qualité exceptionnelle ! La crème visage est légère, non grasse et a significativement amélioré la texture de ma peau.",
      arganOilWonder: "Le sérum à l'huile d'argan a fait des merveilles pour mes cheveux ! Plus souples, plus brillants, et l'odeur naturelle est divine.",
      loyalCustomer: "Client fidèle",
      userFor6Months: "Utilisateur depuis 6 mois",
      newCustomer: "Nouveau client",
      social: "Social",
      followOnInstagram: "Suivez-nous sur Instagram",
      behindTheScenes: "Découvrez notre univers en coulisses et nos dernières actualités",
      elegantMenCollection: "Collection Homme Élégante",
      discoverExcellence: "Découvrez l'excellence des soins naturels pour hommes",
      explore: "Explorer",
      beardFaceCare: "Soins Barbe & Visage",
      premiumFormulations: "Formulations premium pour votre routine quotidienne",
      discover: "Découvrir",
      naturePerformance: "Nature & Performance",
      traditionInnovation: "Alliance parfaite entre tradition marocaine et innovation",
      getStarted: "Commencer",
      pureNature: "NATURE PURE, RÉSULTATS RÉELS",
      discoverCollection: "Découvrir",
      loadingProducts: "Chargement des produits...",
      noProductsAvailable: "Aucun produit disponible pour le moment.",
      tryAgain: "Réessayer",
      productAdded: "ajouté au panier !",
      addedToFavorites: "Produit ajouté aux favoris",
      removedFromFavorites: "Product retiré des favoris"
    },
    en: {
      newCollection: "New Collection",
      ourLatestArrivals: "Our Latest Arrivals",
      latestInnovations: "Discover our latest men's innovations in preview with exclusive natural formulations",
      new: "New",
      addToCart: "Add to Cart",
      viewAllProducts: "View All Products",
      testimonials: "Testimonials",
      whatOurClientsSay: "What Our Clients Say",
      clientExperiences: "Discover the experiences of those who have already trusted our natural products",
      beardOilTransformed: "The beard oil completely transformed my skincare routine. Natural ingredients and visible results from the first week!",
      exceptionalQuality: "Exceptional quality! The face cream is light, non-greasy and has significantly improved my skin texture.",
      arganOilWonder: "The argan oil serum has done wonders for my hair! It's softer, shinier, and the natural scent is absolutely divine.",
      loyalCustomer: "Loyal customer",
      userFor6Months: "User for 6 months",
      newCustomer: "New customer",
      social: "Social",
      followOnInstagram: "Follow Us on Instagram",
      behindTheScenes: "Discover our universe behind the scenes and our latest news",
      elegantMenCollection: "Elegant Men's Collection",
      discoverExcellence: "Discover the excellence of natural care for men",
      explore: "Explore",
      beardFaceCare: "Beard & Face Care",
      premiumFormulations: "Premium formulations for your daily routine",
      discover: "Discover",
      naturePerformance: "Nature & Performance",
      traditionInnovation: "Perfect alliance between Moroccan tradition and innovation",
      getStarted: "Get Started",
      pureNature: "PURE NATURE, REAL RESULTS",
      discoverCollection: "Discover",
      loadingProducts: "Loading products...",
      noProductsAvailable: "No products available at the moment.",
      tryAgain: "Try Again",
      productAdded: "added to cart!",
      addedToFavorites: "Product added to favorites",
      removedFromFavorites: "Product removed from favorites"
    },
    ar: {
      newCollection: "المجموعة الجديدة",
      ourLatestArrivals: "وصلاتنا الأخيرة",
      latestInnovations: "اكتشف أحدث ابتكاراتنا للرجال مع تركيبات طبيعية حصرية",
      new: "جديد",
      addToCart: "أضف إلى السلة",
      viewAllProducts: "عرض جميع المنتجات",
      testimonials: "شهادات",
      whatOurClientsSay: "ما يقوله عملاؤنا",
      clientExperiences: "اكتشف تجارب أولئك الذين وثقوا بمنتجاتنا الطبيعية",
      beardOilTransformed: "زيت اللحية غير روتين العناية بي completely! مكونات طبيعية ونتائج مرئية من الأسبوع الأول!",
      exceptionalQuality: "جودة استثنائية! كريم الوجه خفيف، غير دهني وحسن بشكل ملحوظ ملمس بشرتي.",
      arganOilWonder: "مصل زيت الأركان فعل العجائب لشعري! أصبح أكثر نعومة ولمعاناً، والرائحة الطبيعية رائعة.",
      loyalCustomer: "عميل مخلص",
      userFor6Months: "مستخدم منذ 6 أشهر",
      newCustomer: "عميل جديد",
      social: "اجتماعي",
      followOnInstagram: "تابعنا على إنستغرام",
      behindTheScenes: "اكتشف عالمنا خلف الكواليس وآخر أخبارنا",
      elegantMenCollection: "مجموعة الرجال الأنيقة",
      discoverExcellence: "اكتشف تميز العناية الطبيعية للرجال",
      explore: "استكشف",
      beardFaceCare: "العناية باللحية والوجه",
      premiumFormulations: "تركيبات مميزة لروتينك اليومي",
      discover: "اكتشف",
      naturePerformance: "الطبيعة والأداء",
      traditionInnovation: "تحالف مثالي بين التقاليد المغربية والابتكار",
      getStarted: "ابدأ",
      pureNature: "طبيعة نقية، نتائج حقيقية",
      discoverCollection: "اكتشف",
      loadingProducts: "جاري تحميل المنتجات...",
      noProductsAvailable: "لا توجد منتجات متاحة في الوقت الحالي.",
      tryAgain: "حاول مرة أخرى",
      productAdded: "تمت الإضافة إلى السلة!",
      addedToFavorites: "تمت إضافة المنتج إلى المفضلة",
      removedFromFavorites: "تمت إزالة المنتج من المفضلة"
    }
  };

  const t = (key) => staticTranslations[language]?.[key] || key;

  // Charger la langue depuis le localStorage
  useEffect(() => {
    const savedLanguage = localStorage.getItem('preferredLanguage');
    if (savedLanguage && ['fr', 'en', 'ar'].includes(savedLanguage)) {
      setLanguage(savedLanguage);
    }
  }, []);

  const getProductImage = (product) => {
    if (product.images && typeof product.images === 'string') {
      try {
        const cleanJsonString = product.images.replace(/\\"/g, '"');
        const imagesArray = JSON.parse(cleanJsonString);
        if (imagesArray.length > 0) {
          return `/images/products/${imagesArray[0]}`;
        }
      } catch (error) {
        console.error('Error parsing JSON:', error);
      }
    }
    
    if (product.image) {
      return `/images/products/${product.image}`;
    }
    
    if (product.image_url) {
      return product.image_url;
    }
    
    return '/images/placeholder.jpg';
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const categories = await getCategoriesWithProducts();
        
        const allMenProducts = categories
          .filter(cat => cat.gender === "men")
          .flatMap(cat => cat.products || [])
          .slice(0, 8); 
        
        setNewProducts(allMenProducts);
        setTranslatedProducts(allMenProducts);
      } catch (err) {
        console.error("Error loading products:", err);
        setError("Unable to load products.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();

    setIsFirefox(navigator.userAgent.toLowerCase().includes('firefox'));
  }, []);

  // Traduction des produits quand la langue change
  useEffect(() => {
    const translateProducts = async () => {
      if (newProducts.length === 0 || language === 'fr') {
        setTranslatedProducts(newProducts);
        return;
      }

      setIsTranslating(true);
      try {
        console.log(`🔄 Traduction des ${newProducts.length} produits vers ${language}...`);
        
        const translated = await Promise.all(
          newProducts.map(async (product) => ({
            ...product,
            name: await translateText(product.name, language),
            description: await translateText(product.description || 'Produit de soin naturel de haute qualité', language)
          }))
        );

        setTranslatedProducts(translated);
        console.log(`✅ Traduction terminée pour ${translated.length} produits`);
        
      } catch (error) {
        console.error('❌ Erreur de traduction:', error);
        setTranslatedProducts(newProducts);
      } finally {
        setIsTranslating(false);
      }
    };

    translateProducts();
  }, [newProducts, language]);

  const toggleFavorite = (productId, e) => {
    e.stopPropagation();
    setFavorites(prev => {
      const newFavorites = new Set(prev);
      if (newFavorites.has(productId)) {
        newFavorites.delete(productId);
        // Afficher une notification simple
        alert(t('removedFromFavorites'));
      } else {
        newFavorites.add(productId);
        alert(t('addedToFavorites'));
      }
      return newFavorites;
    });
  };

  const handleAddToCart = (product, e) => {
    e.stopPropagation();
    
    const cartItem = {
      id: product.id,
      name: product.name,
      price: parseFloat(product.price) || 29.99,
      image: getProductImage(product),
      quantity: 1,
      description: product.description
    };
    
    addToCart(cartItem);
    alert(`${product.name} ${t('productAdded')}`);
  };

  const handleProductClick = (productId) => {
    navigate(`/product/${productId}`);
  };

  const handleShopNavigation = () => {
    navigate('/shop?gender=men&category=all');
  };

  if (loading) return (
    <div className="min-h-screen bg-[#fffaf3] flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-[#d0b125] mx-auto mb-4"></div>
        <p className="text-gray-600">{t('loadingProducts')}</p>
      </div>
    </div>
  );

  if (error) return (
    <div className="min-h-screen bg-[#fffaf3] flex items-center justify-center">
      <div className="text-center">
        <p className="text-red-500 text-lg mb-4">{error}</p>
        <button 
          onClick={() => window.location.reload()}
          className="bg-[#d0b125] text-white px-6 py-3 rounded-lg hover:bg-[#b89a20] transition-colors"
        >
          {t('tryAgain')}
        </button>
      </div>
    </div>
  );

  return (
    <div className="overflow-hidden bg-[#fffaf3]">
      {/* Indicateur de traduction */}
      {isTranslating && (
        <div className="bg-[#d0b125] text-white text-center py-2 text-sm sticky top-0 z-40">
          <div className="flex items-center justify-center">
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
            Traduction en cours...
          </div>
        </div>
      )}

      {/* Hero Section - Men's Slider */}
      <section className="relative">
        <HeroCarousel
          slides={[
            {
              image: "/images/hero-men-1.jpg",
              title: t('elegantMenCollection'),
              subtitle: t('discoverExcellence'),
              buttonText: t('explore'),
              buttonLink: "#new-products",
              overlayColor: "bg-gradient-to-r from-[#0f766e] to-[#14b8a6]",
              textColor: "text-white"
            },
            {
              image: "/images/hero-men-2.jpg",
              title: t('beardFaceCare'),
              subtitle: t('premiumFormulations'),
              buttonText: t('discover'),
              buttonLink: "/shop?gender=men&category=beard",
              overlayColor: "bg-gradient-to-r from-[#7c2d12] to-[#ea580c]",
              textColor: "text-white"
            },
            {
              image: "/images/hero-men-3.jpg",
              title: t('naturePerformance'),
              subtitle: t('traditionInnovation'),
              buttonText: t('getStarted'),
              buttonLink: "/shop?gender=men&category=skincare",
              overlayColor: "bg-gradient-to-r from-[#1e3a8a] to-[#3b82f6]",
              textColor: "text-white"
            },
          ]}
          showCounter={false} 
        />
      </section>

      {/* New Products Section */}
      <section id="new-products" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-block mb-4">
              <span className="bg-[#d0b125] text-white px-4 py-2 rounded-full text-sm font-bold tracking-widest uppercase">
                {t('newCollection')}
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-serif font-normal text-[#2f2a1e] mb-6 tracking-wide">
              {t('ourLatestArrivals')}
            </h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto font-light tracking-wide leading-relaxed">
              {t('latestInnovations')}
            </p>
          </div>

          {/* Horizontal products scroll */}
          {translatedProducts.length > 0 ? (
            <div className="relative">
              <div className="flex overflow-x-auto pb-8 gap-6 scrollbar-hide snap-x snap-mandatory">
                {translatedProducts.map((product) => (
                  <div
                    key={product.id}
                    className="flex-none w-80 snap-center bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-[#d0b125]/20 group flex flex-col cursor-pointer"
                    onClick={() => handleProductClick(product.id)}
                  >
                    <div className="relative overflow-hidden rounded-t-2xl">
                      <img
                        src={getProductImage(product)}
                        alt={product.name}
                        className="w-full h-64 object-cover group-hover:scale-110 transition duration-500"
                        onError={(e) => {
                          e.target.src = '/images/placeholder.jpg';
                        }}
                      />
                      
                      <div className="absolute top-3 left-3">
                        <span className="bg-[#d0b125] text-white px-3 py-1 rounded-full text-xs font-bold uppercase shadow-lg">
                          {t('new')}
                        </span>
                      </div>
                      
                      <button
                        onClick={(e) => toggleFavorite(product.id, e)}
                        className="absolute top-3 right-3 p-2 rounded-full bg-white/80 backdrop-blur-sm hover:bg-white transition-colors shadow-lg"
                      >
                        <svg
                          className={`w-5 h-5 ${
                            favorites.has(product.id)
                              ? "text-[#d0b125] fill-current"
                              : "text-gray-400 hover:text-[#d0b125]"
                          } transition-colors`}
                          fill={favorites.has(product.id) ? "currentColor" : "none"}
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                          />
                        </svg>
                      </button>
                    </div>
                    
                    <div className="p-6 flex flex-col flex-grow">
                      <h3 className="font-semibold text-[#2f2a1e] text-lg mb-2 line-clamp-2">
                        {product.name}
                      </h3>
                      <p className="text-gray-600 text-sm mb-4 line-clamp-2 flex-grow">
                        {product.description}
                      </p>
                      
                      <div className="flex justify-between items-center mt-auto pt-4">
                        {/* ✅ CORRIGÉ : Utilisation de la variable 'language' au lieu de 'currentLanguage' */}
                        <span className="text-[#d0b125] font-bold text-xl">
                          {product.price 
                            ? formatPrice(product.price, language, 'MAD') 
                            : formatPrice(29.99, language, 'MAD')
                          }
                        </span>
                        <button 
                          onClick={(e) => handleAddToCart(product, e)}
                          className="bg-[#2f2a1e] text-white px-6 py-3 rounded-lg hover:bg-[#1a1712] transition-colors text-sm font-medium whitespace-nowrap"
                        >
                          {t('addToCart')}
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="text-center py-12">
              <p className="text-gray-500 text-lg">{t('noProductsAvailable')}</p>
            </div>
          )}

          {/* View All Products Button */}
          <div className="text-center mt-16">
            <button 
              onClick={handleShopNavigation}
              className="inline-flex items-center bg-transparent border-2 border-[#2f2a1e] text-[#2f2a1e] px-10 py-4 rounded-full hover:bg-[#2f2a1e] hover:text-white transition-all duration-300 font-semibold text-lg tracking-wide group"
            >
              {t('viewAllProducts')}
              <svg className="w-5 h-5 ml-3 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </button>
          </div>
        </div>
      </section>

      {/* Reviews Section */}
      <section className="py-20 bg-[#f8f5ed]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-block mb-4">
              <span className="bg-[#d0b125] text-white px-4 py-2 rounded-full text-sm font-bold tracking-widest uppercase">
                {t('testimonials')}
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-serif font-normal text-[#2f2a1e] mb-6 tracking-wide">
              {t('whatOurClientsSay')}
            </h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto font-light tracking-wide">
              {t('clientExperiences')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Review 1 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-[#d0b125]/20">
              <div className="flex items-center mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <svg key={star} className="w-5 h-5 text-[#d0b125] fill-current" viewBox="0 0 24 24">
                    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
                  </svg>
                ))}
              </div>
              <p className="text-gray-700 mb-6 italic">
                {t('beardOilTransformed')}
              </p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-[#d0b125] rounded-full flex items-center justify-center text-white font-bold mr-4">
                  SA
                </div>
                <div>
                  <p className="font-semibold text-gray-900">Sébastien A.</p>
                  <p className="text-gray-600 text-sm">{t('loyalCustomer')}</p>
                </div>
              </div>
            </div>

            {/* Review 2 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-[#d0b125]/20">
              <div className="flex items-center mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <svg key={star} className="w-5 h-5 text-[#d0b125] fill-current" viewBox="0 0 24 24">
                    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
                  </svg>
                ))}
              </div>
              <p className="text-gray-700 mb-6 italic">
                {t('exceptionalQuality')}
              </p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-[#2f2a1e] rounded-full flex items-center justify-center text-white font-bold mr-4">
                  KA
                </div>
                <div>
                  <p className="font-semibold text-gray-900">Kevin B.</p>
                  <p className="text-gray-600 text-sm">{t('userFor6Months')}</p>
                </div>
              </div>
            </div>

            {/* Review 3 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-[#d0b125]/20">
              <div className="flex items-center mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <svg key={star} className="w-5 h-5 text-[#d0b125] fill-current" viewBox="0 0 24 24">
                    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
                  </svg>
                ))}
              </div>
              <p className="text-gray-700 mb-6 italic">
                {t('arganOilWonder')}
              </p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-[#d0b125] rounded-full flex items-center justify-center text-white font-bold mr-4">
                  YS
                </div>
                <div>
                  <p className="font-semibold text-gray-900">Yann S.</p>
                  <p className="text-gray-600 text-sm">{t('newCustomer')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Full Width Promotional Video Section */}
      <section className="relative py-0 bg-black">
        <div className="relative w-full h-screen max-h-[800px]">
          
          {isFirefox ? (
            <img
              src="/images/hero-men-1.jpg"
              alt="D4U NATURALLY Collection"
              className="w-full h-full object-cover"
            />
          ) : (
            <>
              <img
                src="/images/hero-men-1.jpg"
                alt="D4U NATURALLY Collection"
                className="absolute inset-0 w-full h-full object-cover md:hidden"
              />
              
              <video
                className="w-full h-full object-cover hidden md:block"
                autoPlay
                muted
                loop
                playsInline
                preload="metadata"
              >
                <source src="/videos/men-collection-promo.mp4" type="video/mp4" />
                <source src="/videos/men-collection-promo.webm" type="video/webm" />
                Votre navigateur ne supporte pas la lecture de vidéos.
              </video>
            </>
          )}
          
          <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
            <div className="text-center text-white px-6 max-w-2xl">
              <div className="mb-6">
                <span className="text-sm font-light tracking-[0.3em] uppercase opacity-90">
                  {t('new')}
                </span>
              </div>

              <h2 className="text-5xl md:text-6xl font-normal mb-4 tracking-wide font-serif">
                D4U NATURALLY
              </h2>
              
              <div className="mb-8">
                <p className="text-lg md:text-xl font-light tracking-[0.2em] uppercase opacity-90 leading-relaxed">
                  {t('pureNature')}
                </p>
              </div>

              <button 
                onClick={handleShopNavigation}
                className="inline-flex items-center border border-white text-white px-8 py-3 hover:bg-white hover:text-black transition-all duration-300 font-light tracking-[0.2em] uppercase text-sm"
              >
                {t('discoverCollection')}
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Instagram Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-block mb-4">
              <span className="bg-[#d0b125] text-white px-4 py-2 rounded-full text-sm font-bold tracking-widest uppercase">
                {t('social')}
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-serif font-normal text-[#2f2a1e] mb-6 tracking-wide">
              {t('followOnInstagram')}
            </h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto font-light tracking-wide">
              {t('behindTheScenes')}
            </p>
            <a 
              href="https://www.instagram.com/d4unaturally" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center text-[#d0b125] font-semibold mt-4 hover:text-[#b89a20] transition-colors"
            >
              @d4u_naturally
              <svg className="w-4 h-4 ml-2" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
          </div>

          {/* Placeholder pour les posts Instagram */}
          
        </div>
      </section>
    </div>
  );
};

export default MenPage;